// @core/api/endpoints/document/cancel_pipeline_execution.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CancelPipelineExecutionRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Cancel pipeline
 * Cancels an active pipeline execution. Pending and in-progress stages are marked as skipped.
 */
export async function CancelPipelineExecution(
  target_type: string,
  target_id: string,
  execution_id: string,
  data: CancelPipelineExecutionRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:target_type/:target_id/pipeline-executions/:execution_id/cancel`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  requestPath = requestPath.replace(':execution_id', encodeURIComponent(execution_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
